import React from 'react';

export default function ConfigHealthBanner() {
  return (
    <div
      style={{
        padding: '8px 12px',
        background: '#f6ffed',
        borderBottom: '1px solid #b7eb8f',
        color: '#237804',
        fontFamily: 'Inter, sans-serif',
        fontSize: '14px',
      }}
    >
      Config health: OK (Phase 1D shell)
    </div>
  );
}
